/* eslint-disable react-hooks/exhaustive-deps */
import { Button, CircularProgress, FormControl, MenuItem, Select } from '@material-ui/core'
import withStyles from '@material-ui/core/styles/withStyles'
import React, { useCallback, useEffect } from 'react'

const styles = () => ({
  root: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: '1rem',
  },
})

function ChartExportSelector({
  chartOptions,
  isLoading,
  onExport,
  classes,
  selectedValue,
  onSelectionChange,
}) {
  const handleChange = useCallback(
    (e) => {
      onSelectionChange(e.target.value)
    },
    [onSelectionChange],
  )

  const handleExport = useCallback(() => {
    if (selectedValue) onExport(selectedValue)
  }, [onExport, selectedValue])

  useEffect(() => {
    onSelectionChange('')
  }, [chartOptions])

  return (
    <div className={classes.root}>
      <FormControl variant="outlined" style={{ minWidth: 240 }} disabled={isLoading}>
        <Select
          value={selectedValue}
          onChange={handleChange}
          displayEmpty
          renderValue={(val) => {
            if (isLoading) return 'Loading charts…'
            if (!val) return 'Select chart to export'
            return chartOptions.find((o) => o.id === val)?.label || ''
          }}
        >
          <MenuItem value="" disabled>
            {isLoading ? 'Loading charts…' : 'Select chart to export'}
          </MenuItem>
          {chartOptions.map(({ id, label, disabled }) => (
            <MenuItem key={id} value={id} disabled={disabled}>
              {label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {isLoading ? (
        <CircularProgress size={24} />
      ) : (
        <Button variant="contained" color="primary" disabled={!selectedValue} onClick={handleExport}>
          Export to CSV
        </Button>
      )}
    </div>
  )
}

export default withStyles(styles)(ChartExportSelector)
